import { I18n as I18nJs } from "i18n-js";
import en from "./en.json";
import fr from "./fr.json";

export const translations = { fr, en };

export const I18n = new I18nJs(translations);

export function configureI18n(locale: string): void {
	I18n.defaultLocale = locale;
	I18n.locale = locale;
	if (typeof document !== "undefined") {
		document.documentElement.lang = locale;
	}
}

export function getLocale(userLanguages: readonly string[]): string {
	for (const lang of userLanguages) {
		const parsedLang = lang.split("-")[0];
		if (parsedLang in translations) {
			return parsedLang;
		}
	}
	return "en";
}
